import useAuth from "../hooks/useAuth";

export default function IsAuth(roless) {
    const { auth } = useAuth();
    return (auth.roles.find(role => roless.includes(role)))
  
}
  